import api from './api';

class CalibrationFeesService {
    // Get fees calculation for a specific application
    async getFeesByAppId(appId) {
        try {
            const response = await api.get(`/calibration-fees/${appId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching fees by AppId:', error);
            throw this.handleError(error);
        }
    }

    // Get calibration fees calculation for a specific application
    async getCalibrationFeesByAppId(appId) {
        try {
            const response = await api.get(`/calibration-fees/calibration/${appId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching calibration fees by AppId:', error);
            throw this.handleError(error);
        }
    }

    // Get fees master data (for reference)
    async getFeesMaster() {
        try {
            const response = await api.get('/calibration-fees/master/all');
            return response.data;
        } catch (error) {
            console.error('Error fetching fees master data:', error);
            throw this.handleError(error);
        }
    }

    // Get application details for fees calculation
    async getApplicationDetails(appId) {
        try {
            const response = await api.get(`/calibration-fees/application/${appId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching application details:', error);
            throw this.handleError(error);
        }
    }

    // Helper method to handle errors consistently
    handleError(error) {
        if (error.response) {
            // Server responded with error status
            return {
                status: 'error',
                message: error.response.data?.message || 'Server error occurred',
                statusCode: error.response.status,
                details: error.response.data?.error || null
            };
        } else if (error.request) {
            // Request made but no response received
            return {
                status: 'error',
                message: 'Network error - please check your connection',
                statusCode: 0,
                details: 'No response from server'
            };
        } else {
            // Something else happened
            return {
                status: 'error',
                message: error.message || 'An unexpected error occurred',
                statusCode: 0,
                details: null
            };
        }
    }

    // Format currency for display
    formatCurrency(amount) {
        if (typeof amount !== 'number') {
            amount = parseFloat(amount) || 0;
        }
        
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(amount);
    }

    // Calculate fees totals from breakdown data
    calculateTotals(feesBreakdown, gstRate = 18) {
        const grossTotal = feesBreakdown.reduce((sum, item) => sum + (item.fees || 0), 0);
        const gstAmount = (grossTotal * gstRate) / 100;
        const grandTotal = grossTotal + gstAmount;

        return {
            grossTotal,
            gstRate,
            gstAmount,
            grandTotal
        };
    }

    // Group fees breakdown by category for better display
    groupFeesByCategory(feesBreakdown) {
        const grouped = {
            baseFees: [],
            locationFees: [],
            collectionCenterFees: []
        };

        feesBreakdown.forEach(item => {
            if (item.category === 'Very Large Laboratories') {
                grouped.baseFees.push(item);
            } else if (item.category.includes('Collection Center')) {
                grouped.collectionCenterFees.push(item);
            } else if (item.category.includes(' - Very Large Laboratories')) {
                grouped.locationFees.push(item);
            }
        });

        return grouped;
    }

    // Validate AppId format
    isValidAppId(appId) {
        return appId && !isNaN(parseInt(appId)) && parseInt(appId) > 0;
    }
}

export default new CalibrationFeesService();